<template>
  <Card>
    <template #title>{{ $t('widgets.charts.devices_being_updated_status_chart.update_status') }}</template>
    <template #content>
      <div class="flex-1 overflow-scroll -mx-4 px-4 sm:-mx-6 sm:px-6 border-t h-full -mt-4">
        <div class="my-10">
          <Chart type="doughnut" :data="chartData" :options="chartOptions" class="w-full md:w-30rem"
                 v-show="showChart"/>
          <div v-show="!showChart">
            {{ $t('widgets.charts.devices_being_updated_status_chart.no_updates_have_been_made_on_this_device') }}
          </div>
        </div>
      </div>
    </template>
  </Card>

</template>

<script>
import {mapStores} from "pinia";
import {useDeviceDownloadLogsStore} from "@/stores/deviceDownloadLogs.js";
import defaultTheme from 'tailwindcss/defaultTheme';

export default {
  name: "DeviceBeingUpdatedStatusChart",
  data() {
    return {
      showChart: false,
      chartData: undefined,
      chartOptions: undefined,
      params: {},
    }
  },
  computed: {
    ...mapStores(useDeviceDownloadLogsStore),
  },
  created() {
    this.chartOptions = this.setChartOptions();
  },
  methods: {
    async refreshDeviceDownloadLogs() {
      let params = this.params;
      params.filter = {'device_id': this.$route.params.device};
      let deviceDownloadLogs = await this.deviceDownloadLogsStore.indexDeviceDownloadLogs(params);
      this.setChartData(deviceDownloadLogs.data);
    },
    setChartOptions(){
      return {
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'start',
          },

          labels: {
            // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
            render: 'value',
            fontStyle: 'bold',
          },
        }
      }
    },
    setChartData(deviceDownloadLogs) {
      const documentStyle = getComputedStyle(document.body);

      const pendingBackgroundColor = documentStyle.getPropertyValue('--chart-gray');
      const initiatedBackgroundColor = documentStyle.getPropertyValue('--chart-blue');
      const completedBackgroundColor = documentStyle.getPropertyValue('--chart-green');
      const cancelledBackgroundColor = documentStyle.getPropertyValue('--chart-orange');
      const failedBackgroundColor = documentStyle.getPropertyValue('--chart-red');

      const pendingBackgroundHoverColor = documentStyle.getPropertyValue('--chart-gray-hover');
      const initiatedBackgroundHoverColor = documentStyle.getPropertyValue('--chart-blue-hover');
      const completedBackgroundHoverColor = documentStyle.getPropertyValue('--chart-green-hover');
      const cancelledBackgroundHoverColor = documentStyle.getPropertyValue('--chart-orange-hover');
      const failedBackgroundHoverColor = documentStyle.getPropertyValue('--chart-red-hover');

      let pending = deviceDownloadLogs.filter(log => log.status === 'PENDING');
      let initiated = deviceDownloadLogs.filter(log => log.status === 'INITIATED');
      let completed = deviceDownloadLogs.filter(log => log.status === 'COMPLETE');
      let cancelled = deviceDownloadLogs.filter(log => log.status === 'CANCELLED');
      let failed = deviceDownloadLogs.filter(log => log.status === 'FAILED');

      if (deviceDownloadLogs.length > 0) this.showChart = true;

      this.chartData = {
        labels: [
          'PENDING',
          'INITIATED',
          'COMPLETE',
          'CANCELLED',
          'FAILED'
        ],
        datasets: [
          {
            data: [
              pending.length,
              initiated.length,
              completed.length,
              cancelled.length,
              failed.length
            ],
            backgroundColor: [
              pendingBackgroundColor,
              initiatedBackgroundColor,
              completedBackgroundColor,
              cancelledBackgroundColor,
              failedBackgroundColor,
            ],
            hoverBackgroundColor: [
              pendingBackgroundHoverColor,
              initiatedBackgroundHoverColor,
              completedBackgroundHoverColor,
              cancelledBackgroundHoverColor,
              failedBackgroundHoverColor,
            ],
            hoverBorderColor: '#fff'
          }
        ]
      };
    },

  },
  components: {},
  async mounted() {
    await this.refreshDeviceDownloadLogs()
  }
}
</script>

<style>
</style>
